export enum ChartPieType {
  STANDARD = 'STANDARD',
  DONUT = 'DONUT',
  HALF_DONUT = 'HALF_DONUT',
  VARIABLE_RADIUS = 'VARIABLE_RADIUS'
}
